export enum ServiceProvider {
  Kerberos = 'kerberos',
  Legeartis = 'legeartis',
}
